<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "Time Spent in Low Temperature" chart.
    </rb-callout>
</div>
<div id="time-spent-extreme-temp-low-ef-chart"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container ">
        Percentage of vehicles that spent a certain amount (indicated by x-axis) very cold temperature conditions along with the corresponding value(s) of the selected vehicle(s). The higher the amount of time spent in extreme conditions, the more the battery might be affected negatively. Typically, also the charging speed is reduced significantly and the charging takes more time than usual. Furthermore, the range can be also reduced in low temperatures.
    </div>
</div>